// extracted by mini-css-extract-plugin
export default {"buttons":"FiscalAddress_buttons__HnVRe"};